import { ShieldCheck, Clock, Award, HeartHandshake } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, label: "Preferred by major insurers" },
  { icon: Clock, label: "24/7 on-call support" },
  { icon: Award, label: "Licensed & accredited" },
  { icon: HeartHandshake, label: "Compassionate, vetted caregivers" },
];

export const TrustBar = () => (
  <div className="bg-card border-y border-border" data-testid="trust-bar">
    <div className="container-page py-6 grid grid-cols-2 lg:grid-cols-4 gap-4">
      {ITEMS.map((it) => (
        <div key={it.label} className="flex items-center gap-3">
          <span className="grid place-items-center w-11 h-11 rounded-xl bg-primary/10 text-primary shrink-0">
            <it.icon className="w-6 h-6" />
          </span>
          <span className="font-semibold text-foreground/90 leading-tight">{it.label}</span>
        </div>
      ))}
    </div>
  </div>
);
